
<div class="modal-dialog confirm-dialog">
  <div class="modal-content" style="min-width:630px;">
    <form #orderForm="ngForm">
      <div class="modal-header">
        <h4 class="modal-title">Notify Transition Lead of Disabling Order Acceptance</h4>
        <button class="close" type="button" (click)="cancel()">&times;</button>
      </div>
      <div class="container">
        <div class="row mt-2">
          <div class="col">
            <error [error]="error"></error>
          </div>
        </div>
      </div>
      <div class="modal-body">
        <label class="required" for="messageTextArea">Please describe the reason for turning off order acceptance.</label>
        <textarea class="form-control" id="messageTextArea" [(ngModel)]="message" name="message" maxlength="500" required></textarea>
        <validation-error-display [error]="error" field="message"></validation-error-display>
      </div>
      <div class="modal-footer">
        <button class="btn btn-primary" type="submit" (click)="finish()">Finish</button>
        <button class="btn btn-outline-secondary" type="button" (click)="cancel()">Cancel</button>
      </div>
    </form>
  </div>
</div>